import React from 'react'
import { Box, LinearProgress, linearProgressClasses } from '@mui/material'
import { ProgressStepperProps } from './types'
import { RunningIcon } from '../../components/Icons/RunningIcon'
import { styled } from '@mui/material'

export const ProgressStepper: React.FC<ProgressStepperProps> = ({
  step,
  totalSteps,
  boxHeight
}) => {
  const total = totalSteps || 8
  const progress = step === total ? 100 : Math.round(100 / total) * step

  const LinearProgressBar = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[200]
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundImage: `linear-gradient(to right, ${theme.palette.gradient.main}, ${theme.palette.secondary.main})`
    }
  }))

  return (
    <Box
      sx={{
        height: boxHeight || '3.4rem',
        width: '100%'
      }}
    >
      <RunningIcon
        style={{
          height: '1rem',
          left: `${progress}%`,
          position: 'relative',
          marginLeft: -15
        }}
      />
      <LinearProgressBar variant="determinate" value={progress} />
    </Box>
  )
}
